import Quotation from 'views/Quotation'

const QuotationPage = () => {
  return <Quotation />
}

QuotationPage.Layout = QuotationPage
// QuotationPage.mp = false

export default QuotationPage
